module.exports = __webpack_public_path__ + "cb2057a524450fb7ae3ea3b1a0b2c386.pdf";